$(function () {

  $('[data-toggle*="promotion-add"]').on('submit', function (e) {
    e.preventDefault();

    const policy = $('select[name="policy"]', this).val();
    const agreement = $('input[name="regulations_accepted"]', this).is(':checked') ? 1 : 0;
    const promotionId = $('input[name="promotionId"]', this).val();

    const data = {
      add: 1,
      policy: policy,
      agreement: agreement,
      promotionId: promotionId,
      action: 'insert_promotion_form',
    };

    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: data,
      success: function (response) {
        $('.section--promotion-form .main-form').html(response);
      },
      error: function (jqXhr) {
        if (jqXhr.status === 400) {
          $('.section--promotion-form .promo-form-errors').html(jqXhr.responseText);
        }
      }
    });
  });

  const accordion = $('.accordion');
  let i;

  for (i = 0; i < accordion.length; i++) {
    accordion[i].addEventListener("click", function () {
      this.classList.toggle("active");

      var details = this.nextElementSibling;
      console.log(details);
      if (details.style.maxHeight) {
        details.style.maxHeight = null;
      } else {
        details.style.maxHeight = details.scrollHeight + "px";
      }
    });
  }

});
